import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';

import { BookingEvent } from '@bookings/interfaces/booking-event';

import BookingEventTable from '@bookings/components/tables/booking-event-table/booking-event-table.vue';
import { BPCDisplayConfigField } from '@core/interfaces/bpc-display-config';

@Component({
  name: 'bpc-booking-event-table-input',
  components: {
    'bpc-booking-event-table': BookingEventTable,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class BookingEventTableInput extends mixins(AbstractField) {
  $refs: {
    bookingEventTable: InstanceType<typeof BookingEventTable> & {
      fields: BPCDisplayConfigField[];
    };
  };

  @Prop(Array) readonly value: any[];

  @Prop({ type: String, default: 'drawer' }) readonly type: string;
  @Prop(String) readonly selectEntity: string;

  @Prop(Array) readonly filters: any[];
  @Prop(String) readonly fieldForStorage: string;

  @Prop(Boolean) readonly withDraft: boolean;
  @Prop({ type: Boolean, default: false }) readonly forceApiMode: boolean;
  @Prop({ type: Boolean, default: false }) readonly showTableHeader: boolean;
  @Prop({ type: Boolean, default: false }) readonly showTitle: boolean;
  @Prop({ type: String, default: 'default' }) readonly formConfigName: string;
  @Prop({ type: String, default: null }) readonly filterConfigName: string;
  @Prop({ type: String, default: null }) readonly bookingFormConfigName: string;
  @Prop({ type: String, default: null }) readonly bookingEventFormConfigName: string;
  @Prop({ type: Boolean, default: false }) readonly withFilters: boolean;
  @Prop({ type: Boolean, default: false }) readonly withTabFilters: boolean;

  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;
  @Prop({ type: String, default: 'table-input' }) readonly displayConfigName: string;

  get model(): any[] {
    return this.value;
  }
  set model(val: any[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  get bookingId(): number {
    const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
    if (!!filter && filter['value']) {
      return Number(filter['value']);
    } else {
      return null;
    }
  }
  get contactId(): number {
    return this.formModel && this.formModel['contact_id'] ? this.formModel['contact_id'] : null;
  }

  public entity: BookingEvent = null;
  public entityName = 'booking-event';
  public pluralEntityName = 'booking-events';
  public permissionEntityNameToUse = 'bookings';

  onChange($event) {
    this.$emit('change', $event);
  }

  // TODO: Determine if model has ID or not to consume api or create in localstorage.
  get mode(): string {
    if (this.bookingId) {
      return 'api';
    } else if (this.forceApiMode) {
      return 'api';
    } else {
      return 'storage';
    }
  }

  get realFormConfigName(): string {
    if (this.bookingId) {
      return 'default-without-booking';
    } else {
      return this.formConfigName;
    }
  }

  // onFormSave() {
  //   console.log('Saving');
  //   const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
  //   if (filter['value']) {
  //     this.$refs.stdForm.formModel[filter['filterField']] = filter['value'];
  //   }
  //   this.$refs.stdForm.saveEntity();
  // }

  // onNew() {
  //   this.entity = null;
  //   this.showForm = true;
  //   if (this.type === 'drawer') {
  //     // this.$bvModal.show('modal-resource-form');
  //     this.showDrawerSection = true;
  //   } else if (this.type === 'modal') {
  //     this.$bvModal.show(`${this.selectEntity}-entity-table-input-modal`);
  //   }
  // }

  // onEdit(e) {
  //   console.log('clickOnEdit', e);
  //   this.entity = e.item;
  //   this.showForm = true;
  //   if (this.type === 'drawer') {
  //     this.showDrawerSection = true;
  //   } else if (this.type === 'modal') {
  //     this.$bvModal.show(`${this.selectEntity}-entity-table-input-modal`);
  //   }
  // }

  // onFormClose() {
  //   this.showForm = false;
  //   if (this.type === 'drawer') {
  //     this.showDrawerSection = false;
  //   } else if (this.type === 'modal') {
  //     this.$bvModal.hide(`${this.selectEntity}-entity-table-input-modal`);
  //   }
  //   this.showDrawerSection = false;
  // }

  // @Watch('value')
  // updateItemsProvider() {
  //   this.$refs.provider.items = this.value;
  //   if (this.value) {
  //     this.$bpcStorage.set(this.selectPluralEntity, this.value);
  //     this.updateRowsActions();
  //   }
  //   console.log('change items provider');
  // }
}
